import { AuthenticationMode } from '@softline/auth';
import { environment } from '../environments/environment';

export const authenticationMode: AuthenticationMode = environment.authentication;
